<template>
    <div v-wechat-title="title" style="height: 100%">
        <div class="addEventType">
            <el-button type="primary" size="mini" @click="addEventType">创建事件类型</el-button>
        </div>
        <crud-facecade
            ref="dicevents-list"
            :columns="columnList"
            :buttons="eventButtons"
            :url="url"
            class="left"
            :tableHeight="tableHeight"
            :addButton="{ enabled: false, label: '创建事件' }"
            :updateButton="{ enabled: false }"
            @rowClick="activRow"
            @updateEventType="updateEventType"
            @addEvent="addEvent"
            @addEventType="addEventType"
            :filterSpan="[18, 6, 8]"
        >
            <div slot="filter">
                <el-col :span="10">
                    <item-input type="select" v-model="enum_adverse_type" :options="sys_enums.AdverseEventType" :clearable="true" placeholder="属性"></item-input>
                </el-col>
                <el-col :span="14">
                    <item-input type="groupselect" v-model="dic_ward_id" :options="ward_auth" :clearable="true" placeholder="请选择区域"></item-input>
                </el-col>
            </div>
        </crud-facecade>
        <ListView :columns="eventViewColumns" :buttons="eventViewButtons" :datalist="eventData" @extrabutton-click="ExtraButtonClick" :tableHeight="tableHeight" class="right"> </ListView>

        <form-dialog :title="eventTypeView.title" :visible.sync="eventTypeView.dialogFormVisible" :data="eventTypeView.data" :columns="eventTypeColumns" width="30%" @confirm="SaveEventType"> </form-dialog>

        <form-dialog title="创建事件" :visible.sync="eventView.dialogFormVisible" :data="eventView.data" :columns="eventColumns" width="50%" @confirm="SaveEvent"> </form-dialog>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    name: `EventType`,
    props: {},
    data() {
        return {
            title: `不良事件维护`,
            active_event_type_id: 0,
            enum_adverse_type: undefined,
            issetoperatingward: false,
            o_dic_ward_id: undefined,
            categoryList: [],
            eventsData: [],
            eventData: [],
            url: {
                baseURL: `/api/AcisSystem/AdverseCategory`,
                get: () => {
                    return new Promise(resolve => {
                        this.loadDicEventGroup(resolve)
                    })
                },
                putMany: row => {
                    return new Promise(resolve => {
                        let req = this.myaxios.put(`/api/AcisSystem/AdverseCategory/PutMany`, row)
                        req.then(data => {
                            resolve(data)
                        }).catch(e => {
                            console.log(e)
                        })
                    })
                }
            },
            eventTypeView: {
                title: `创建事件类型`,
                dialogFormVisible: false,
                data: {}
            },
            eventView: {
                dialogFormVisible: false,
                data: {}
            }
        }
    },
    created() {
        if (this.token) {
            sessionStorage.setItem(`token`, this.token)
        }
    },
    computed: {
        ...mapGetters([`ward_auth`, `sys_enums`, `screenHeight`, `active_ward`]),
        dic_ward_id: {
            get: function() {
                if (!this.issetoperatingward && this.active_ward) {
                    this.o_dic_ward_id = this.active_ward.value
                }
                return this.o_dic_ward_id
            },
            set: function(v) {
                this.o_dic_ward_id = v
                this.issetoperatingward = true
            }
        },
        tableHeight() {
            return (this.screenHeight && this.screenHeight - 190) || 0
        },
        columnList() {
            return [
                {
                    type: `string`,
                    prop: `id`,
                    label: `序号`,
                    isKey: true
                },
                {
                    type: `radio`,
                    prop: `enum_adverse_type`,
                    label: `属性`,
                    width: `80`,
                    colspan: 24,
                    isEditable: true,
                    isCreatable: true,
                    isListable: true,
                    options: this.sys_enums.AdverseEventType || [],
                    default: 1
                },
                {
                    type: `string`,
                    prop: `name`,
                    label: `事件类型名称`,
                    colspan: 24,
                    isEditable: true,
                    isCreatable: true,
                    isListable: true,
                    validate: [{ required: true, message: `必填项目`, trigger: `change` }]
                },
                {
                    type: `rbool`,
                    prop: `is_deleted`,
                    label: `状态`,
                    width: `50`,
                    isListable: true,
                    isExpand: false,
                    // isEditable: true,
                    // isCreatable: true,
                    readonly: false,
                    options: `is_enabled`,
                    default: false
                },
                {
                    type: `groupmultiselect`,
                    prop: `dic_ward_ids`,
                    label: `可用区域`,
                    colspan: 24,
                    isEditable: true,
                    isCreatable: true,
                    isListable: false,
                    options: this.ward_auth
                }
            ]
        },
        eventButtons() {
            return [
                {
                    class: `is-plain`,
                    label: `编辑`,
                    icon: ``,
                    type: `primary`,
                    emit: `updateEventType`, // LoadingUpdateView
                    permission: `default`
                },
                {
                    class: `is-plain`,
                    label: `创建事件`,
                    icon: ``,
                    type: `primary`,
                    emit: `addEvent`,
                    permission: `default`
                }
            ]
        },
        eventViewColumns() {
            return [
                {
                    type: `string`,
                    prop: `id`,
                    label: `序号`,
                    isKey: true
                },
                {
                    type: `string`,
                    prop: `name`,
                    label: `事件名称`,
                    isListable: true
                }
            ]
        },
        eventViewButtons() {
            return [
                {
                    class: `is-plain`,
                    label: `编辑`,
                    icon: ``,
                    type: `primary`,
                    emit: `addEvent`,
                    permission: `default`
                },
                {
                    class: `is-plain`,
                    label: `删除`,
                    icon: ``,
                    type: `danger`,
                    emit: `deleteEvent`,
                    permission: `default`
                }
            ]
        },
        eventTypeColumns() {
            return [
                {
                    type: `radio`,
                    prop: `enum_adverse_type`,
                    label: `属性`,
                    colspan: 24,
                    options: this.sys_enums.AdverseEventType || [],
                    default: 1
                },
                {
                    type: `string`,
                    prop: `name`,
                    label: `事件类型名称`,
                    colspan: 24,
                    validate: [{ required: true, message: `必填项目`, trigger: `change` }]
                },
                {
                    type: `groupmultiselect`,
                    prop: `dic_ward_ids`,
                    label: `可用区域`,
                    colspan: 24,
                    options: this.ward_auth,
                    readonly: function(that, { row, column, area }) {
                        if (area == `form`) {
                            return row.region_type === 1
                        } else {
                            return true
                        }
                    }
                }
            ]
        },
        eventColumns() {
            return [
                {
                    type: `p`,
                    prop: `adverse_type`,
                    label: `属性`,
                    colspan: 24,
                    readonly: true
                },
                {
                    type: `string`,
                    prop: `group_name`,
                    label: `事件类型名称`,
                    colspan: 24,
                    readonly: true
                },
                {
                    type: `string`,
                    prop: `name`,
                    label: `事件名称`,
                    colspan: 24,
                    validate: [{ required: true, message: `必填项目`, trigger: `change` }]
                }
            ]
        }
    },
    mounted() {},
    methods: {
        loadDicEventGroup(resolve) {
            let that = this
            that.active_event_type_id = 0
            let req = this.myaxios.get(`/api/AcisSystem/AdverseCategory/Get`)
            req.then(data => {
                that.categoryList = _.filter(data, function(d) {
                    return d.enum_adverse_type === that.enum_adverse_type || !that.enum_adverse_type
                })
                _.forEach(that.categoryList, r => {
                    r.dic_ward_ids =
                        (r.regions &&
                            r.regions.map(d => {
                                return (d.dic_operating_ward_id && `ow_${d.dic_operating_ward_id}`) || (d.dic_recovery_ward_id && `rw_${d.dic_recovery_ward_id}`)
                            })) ||
                        []
                })
                if (that.dic_ward_id) {
                    that.categoryList = _.filter(that.categoryList, function(d) {
                        return !d.dic_ward_ids || d.dic_ward_ids.length == 0 || _.includes(d.dic_ward_ids, that.dic_ward_id)
                    })
                }
                that.loadAdverseEventGroups()
                resolve(that.categoryList)
            }).catch(e => {
                console.log(e)
            })
        },
        ExtraButtonClick(target) {
            this[target.emit](target)
        },
        addEventType({ row }) {
            this.eventTypeView.data = {}
            if (row) {
                this.eventTypeView.data = row
            }
            this.eventTypeView.dialogFormVisible = true
        },
        updateEventType({ row }) {
            this.eventTypeView.title = `修改事件类型`
            this.eventTypeView.data = {}
            if (row) {
                this.eventTypeView.data = row
            }
            this.eventTypeView.dialogFormVisible = true
        },
        SaveEventType(row) {
            let data = {
                id: (row && row.id) || 0,
                name: row.name,
                enum_adverse_type: row.enum_adverse_type,
                is_deleted: false,
                regions: row.dic_ward_ids && row.dic_ward_ids.map(d => {
                    return {
                        dic_operating_ward_id: _.startsWith(d, `ow_`) ? d.substr(3) : 0,
                        dic_recovery_ward_id: _.startsWith(d, `rw_`) ? d.substr(3) : 0
                    }
                })
            }
            let req
            if (row && row.id) {
                req = this.myaxios.put(`/api/AcisSystem/AdverseCategory/put`, data)
            } else {
                req = this.myaxios.post(`/api/AcisSystem/AdverseCategory/post`, data)
            }
            req.then(data => {
                this.$refs[`dicevents-list`].ReloadListData()
                this.eventTypeView.dialogFormVisible = false
            }).catch(e => {
                console.log(e)
            })
        },
        activRow({ row }) {
            if (row && row.id) {
                this.active_event_type_id = row.id
            }
            this.loadAdverseEventGroups()
        },
        loadAdverseEventGroups() {
            this.active_event_type_id = this.active_event_type_id === 0 ? this.categoryList && this.categoryList[0] && this.categoryList[0].id : this.active_event_type_id
            return new Promise(resolve => {
                let req = this.myaxios.get(`/api/AcisSystem/AdverseEvent/GetByCategoryId/Get?id=${this.active_event_type_id}`)
                req.then(data => {
                    this.eventData = _.filter(data, { is_deleted: false })
                }).catch(e => {
                    console.log(e)
                })
            })
        },
        addEvent({ row }) {
            this.eventView.data = {
                id: row && row.dic_adverse_category_id !== undefined ? row.id : 0,
                dic_adverse_category_id: row.dic_adverse_category_id !== undefined ? row.dic_adverse_category_id : row.id,
                group_name: row && row.dic_adverse_category_id !== undefined ? row.group_name : row.name,
                enum_adverse_type: row.enum_adverse_type,
                adverse_type: row.adverse_type,
                name: row && row.dic_adverse_category_id && row.name,
                is_deleted: false
            }
            this.eventView.dialogFormVisible = true
        },
        SaveEvent(row) {
            let data = {
                id: row.id,
                dic_adverse_category_id: row.dic_adverse_category_id,
                name: row.name,
                is_deleted: row.is_deleted
            }
            let req
            if (row.id === 0) {
                req = this.myaxios.post(`/api/AcisSystem/AdverseEvent/Post`, data)
            } else {
                req = this.myaxios.put(`/api/AcisSystem/AdverseEvent/Put`, data)
            }
            req.then(data => {
                this.active_event_type_id = data.dic_adverse_category_id
                this.loadAdverseEventGroups()
                this.eventView.dialogFormVisible = false
            }).catch(e => {
                console.log(e)
            })
        },
        deleteEvent({ row, index }) {
            this.$confirm(`此操作将永久删除该记录, 是否继续?`, `提示`, {
                confirmButtonText: `确定`,
                cancelButtonText: `取消`,
                type: `warning`,
                closeOnClickModal: false
            }).then(() => {
                let req = this.myaxios.delete(`/api/AcisSystem/AdverseEvent/Delete?id=${row && row.id}`)
                req.then(data => {
                    this.eventData.splice(index, 1)
                }).catch(e => {
                    console.log(e)
                })
            })
        }
    },
    watch: {
        enum_adverse_type(newValue, oldValue) {
            this.enum_adverse_type = newValue
            this.$refs[`dicevents-list`].ReloadListData()
        },
        dic_ward_id(newValue, oldValue) {
            this.dic_ward_id = newValue
            this.$refs[`dicevents-list`].ReloadListData()
        }
    }
}
</script>
<style scoped>
.addEventType {
    position: absolute;
    top: 20px;
    right: 20px;
}
.right {
    width: 40% !important;
    position: absolute !important;
    right: 10px;
    top: 68px;
}
.left {
    width: 56% !important;
    position: absolute !important;
    left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/AdverseEvent/EventType.vue